
import { useEffect, useContext, useState } from "react";
import HttpClient from "../../utils/HttpClient";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import SeoMetaData from "./SeoMetaData";
import ProfileSkeleton from "../SearchHome/skeletons/ProfileSkeleton";
import ProfileSectionComponent from "./Components/ProfileSectionComponent";
import BannerComponent from "./Components/BannerComponent";
import AboutUsComponent from "./Components/AboutUsComponent";
import ServicesComponent from "./Components/ServicesComponent";
import ImageGalleryComponent from "./Components/ImageGalleryComponent";
import SocialMediaComponent from "./Components/SocialMediaComponent";
// import EnquiryComponent from "./Components/EnquiryComponent";
import ContactDetailsComponent from "./Components/ContactDetailsComponent";
import { Colorcontext } from '../../Component/Colorcontext/ColorContext';
import JsonLd from "../BusinessListing/components/JsonLd";

const BusinessPagePublic = () => {
    const [data, setData] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    const params = useParams();

    useEffect(() => {
        if (params?.name) {
            const res = HttpClient.requestData(`business-details-public`, "POST", { slug: params?.name }).then((res) => {
                if (res.data.length === 0) {
                    navigate("/");
                    return;
                }
                setData(res.data[0]);
                setIsLoading(false);
            }).catch((error) => {
                console.error("Error fetching business details:", error);
            });
        } else {
            navigate("/");
        }
    }, [params?.name])

    const colordata = useContext(Colorcontext);
    useEffect(() => {
        colordata.setcolor(true);
        return () => {
            colordata.setcolor(false);
        };
    }, []);

    const schema = {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        name: data?.companyName,
        description: data?.aboutBusiness,
        url: `${process.env.REACT_APP_APPLICATION_URL}/businesspage/${data?.companySlug}`,
        logo: data?.businessProfilePic,
        image: data?.gallery?.map(item => item?.image).filter(Boolean),
        telephone: data?.telephoneNo
            ? `${data?.phone_code} ${data?.telephoneNo}`
            : undefined,
        email: data?.emailId,
        address: {
            "@type": "PostalAddress",
            streetAddress: data?.address,
            addressLocality: data?.location,
            addressRegion: data?.emirate,
            addressCountry: data?.countryName
        },
        hasMap: data?.businessLocationLink || undefined,
        sameAs: [
            data?.businessFacebookLink,
            data?.businessLinkedInLink,
            data?.businessInstaLink
        ].filter(Boolean),
        aggregateRating:
            data?.pageRating?.length > 0
                ? {
                    "@type": "AggregateRating",
                    ratingValue: Number(data?.PageAvgRating).toFixed(1),
                    reviewCount: data?.pageRating.length
                }
                : undefined,
        areaServed: {
            "@type": "Place",
            name: data?.location
        },
        hasOfferCatalog:
            data?.businessProductCat?.length > 0
                ? {
                    "@type": "OfferCatalog",
                    name: "Services",
                    itemListElement: data.businessProductCat.map(item => ({
                        "@type": "Offer",
                        itemOffered: {
                            "@type": "Service",
                            name: item
                        }
                    }))
                }
                : undefined
    };

    return (
        <>
            <SeoMetaData data={data} />
            <JsonLd data={schema} />
            <section className="ownblmprofiledivmaoin">
                <div className="cust_container">
                    {isLoading ? <ProfileSkeleton /> :
                        <>
                            <div className="reposivecideforspecial">
                                <div className="ownblmprofiledivleft">
                                    <div className="repsonsivedivcls">

                                        {/* For Tablet responsive code start  */}
                                        <div className="tab-sec-div">
                                            <div className="oenblmsnfdrpbapbbtm responsivdedivmain">
                                                <BannerComponent data={data} />
                                            </div>
                                            <div className="oenblmsnfdrpbapbbtm responsivdedivmain">
                                                <ProfileSectionComponent data={data} />
                                            </div>
                                            <div className="oenblmsnfdrpbapbbtm responsivdedivmain">
                                                <ContactDetailsComponent data={data} />
                                            </div>
                                        </div>
                                        {/* For Tablet responsive code end */}
                                    </div>

                                    <div className="oenblmsnfdrpbapbbtm deslrtopwdijjsmain">
                                        <ProfileSectionComponent data={data} />
                                    </div>

                                    <div className="oenblmsnfdrpbapbbtm deslrtopwdijjsmain">
                                        <ContactDetailsComponent data={data} />
                                    </div>
                                </div>

                                <div className="ownblmprofiledivright">
                                    <div className="oenblmsnfdrpbapbbtm deslrtopwdijjsmain">
                                        <BannerComponent data={data} />
                                    </div>
                                    <div className="oenblmsnfdrpbapbbtm">
                                        <AboutUsComponent data={data} />
                                    </div>
                                    <div className="oenblmsnfdrpbapbbtm">
                                        <ServicesComponent data={data} />
                                    </div>
                                    <div className="oenblmsnfdrpbapbbtm">
                                        <ImageGalleryComponent data={data} />
                                    </div>
                                    <div className="oenblmsnfdrpbapbbtm">
                                        <SocialMediaComponent data={data} />
                                    </div>
                                </div>
                            </div>

                            {/* Mobile Screen Design Start */}
                            <div className="mobilereposiveprofile">
                                <div className="bannerprofileblmreposnive">
                                    <BannerComponent data={data} />
                                </div>
                                <div className="mobilereposvispsicaldivflx mt-2">
                                    <div className="eidteprofileblmreposnive2">
                                        <ProfileSectionComponent data={data} />
                                    </div>
                                </div>
                                <div className="contaallprofileblmreposnive mt-2">
                                    <ContactDetailsComponent data={data} />
                                </div>
                                <div className="contaallprofileblmreposnive">
                                    <AboutUsComponent data={data} />
                                </div>
                                <div className="contaallprofileblmreposnive">
                                    <ServicesComponent data={data} />
                                </div>
                                <div className="contaallprofileblmreposnive">
                                    <ImageGalleryComponent data={data} />
                                </div>
                                <div className="contaallprofileblmreposnive">
                                    <SocialMediaComponent data={data} />
                                </div>
                            </div>
                            {/* Mobile Screen Design End */}
                        </>
                    }
                </div>
            </section>
        </>
    );
};
export default BusinessPagePublic;
